import { Dispatch, useContext, useEffect, useState } from 'react';
import { CardStyled, Label } from '../../../../styles/style';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ProductListingContext } from '../../functions/data_formatting_functions';
import {
  actionSetAllAttributes,
  actionSetListingData,
} from '../../store/create_listing_actions';
// import BarcodeModal from '../../modals/add_barcode_modal';
import Wrapper from './item_information_screen.styled';
import CategoryModal from '../../modals/select_category_modal';
import { SelectDiv } from '../../components/select_div';
import Error from '../../../../components/error';
import { FIELD_CHAR_LENGTH, RequiredSign } from '../../constants';
import { toast } from 'react-toastify';
import {
  AbstractCategoryWithSubcategories,
  Category,
} from '../../../../data/types/categories';
import {
  HelpBox,
  OneLanguageTranslateButton,
} from '../../components/create_listings_components';
import UtilitiesRepository from '../../../../data/repositories/utilities_repository';
import { ListingState } from '../../../../data/types/listings';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { AttributeType } from '../../../../data/types/attributes';
import SharedRepository from '../../../../data/repositories/shared_repository';
import { Form, Input, Row } from 'antd';
import { Button, Checkbox } from '@nextui-org/react';

const DESCRIPTION_MIN_LENGTH = 50;
const NAME_MIN_LENGTH = 10;

type InformationProps = {
  addStep: () => void;
};

export default function Information({ addStep }: InformationProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const selected_category = state.data.category;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [errors, setErrors] = useState({
    name_en: '',
    name_ar: '',
    category: '',
    description_en: '',
    description_ar: '',
  });

  const [autoTuneName, setAutoTuneName] = useState(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      actionSetListingData({ ...state.data, [e.target.name]: e.target.value }),
    );
  };

  useEffect(() => {
    dispatch(
      actionSetListingData({
        ...state.data,
        description_en: state.data.description_en,
        description_ar: state.data.description_ar,
      }),
    );
  }, [state.data.description_en, state.data.description_ar]);

  const handleValidations = () => {
    const errorsFields = {
      name_en: '',
      name_ar: '',
      category: '',
      description: '',
      description_en: '',
      description_ar: '',
    };
    let error = false;
    Object.keys(state.data).map(function (keyName) {
      const value = state.data[keyName as keyof typeof state.data];
      if (keyName === 'name_en') {
        if (!value) {
          errorsFields[keyName] = 'ⓘ Listing name in English is required.';
          error = true;
          toast.warn(errorsFields.name_en);
        }
        if (
          keyName === 'name_en' &&
          state.data.name_en
            ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
            .replaceAll(/&nbsp;/g, ' ')
            .trim().length < NAME_MIN_LENGTH
        ) {
          errorsFields.name_en = `ⓘ Name (ENGLISH) must be at least ${NAME_MIN_LENGTH} characters.`;
          error = true;
          toast.warn(errorsFields.name_en);
        }
        if (
          value !== null &&
          (value as string).length > FIELD_CHAR_LENGTH.ENGLISH_NAME
        ) {
          errorsFields.name_en = `ⓘ Name must be less then ${FIELD_CHAR_LENGTH.ENGLISH_NAME} characters.`;
          error = true;
          toast.warn(errorsFields.name_en);
        }
      }

      if (keyName === 'name_ar') {
        if (!value) {
          errorsFields[keyName] = 'ⓘ Listing name in Arabic is required.';
          error = true;
          toast.warn(errorsFields.name_ar);
        }
        if (
          keyName === 'name_ar' &&
          state.data.name_ar
            ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
            .replaceAll(/&nbsp;/g, ' ')
            .trim().length < NAME_MIN_LENGTH
        ) {
          errorsFields.name_ar = `ⓘ Name (ARABIC) must be at least ${NAME_MIN_LENGTH} characters.`;
          error = true;
          toast.warn(errorsFields.name_ar);
        }
        if (
          value !== null &&
          (value as string).length > FIELD_CHAR_LENGTH.ARABIC_NAME
        ) {
          errorsFields.name_ar = `ⓘ Name must be less then ${FIELD_CHAR_LENGTH.ARABIC_NAME} characters.`;
          error = true;
          toast.warn(errorsFields.name_ar);
        }
      }

      if (keyName === 'category_id') {
        if (!value) {
          errorsFields.category = 'ⓘ Category is required.';
          error = true;
          toast.warn(errorsFields.category);
        }
      }

      if (keyName === 'description_en' || keyName === 'description_ar') {
        if (
          !errorsFields.description &&
          !state.data.description_en &&
          !state.data.description_ar
        ) {
          error = true;
          errorsFields.description =
            'ⓘ Description in at least one language is required.';
          toast.warn('ⓘ Description in at least one language is required.');
        }
        if (
          keyName === 'description_en' &&
          state.data.description_en
            ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
            .replaceAll(/&nbsp;/g, ' ')
            .trim().length < DESCRIPTION_MIN_LENGTH
        ) {
          errorsFields.description_en = `ⓘ Description (ENGLISH) must be at least ${DESCRIPTION_MIN_LENGTH} characters.`;
          error = true;
          toast.warn(errorsFields.description_en);
        }
        if (
          keyName === 'description_ar' &&
          state.data.description_ar
            ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
            .replaceAll(/&nbsp;/g, ' ')
            .trim().length < DESCRIPTION_MIN_LENGTH
        ) {
          errorsFields.description_ar = `ⓘ Description (عربي) must be at least ${DESCRIPTION_MIN_LENGTH} characters.`;
          error = true;
          toast.warn(errorsFields.description_ar);
        }
        if (keyName === 'description_en') {
          if (
            state.data.description_en.length >
            FIELD_CHAR_LENGTH.ENGLISH_DESCRIPTION
          ) {
            errorsFields.description_en = `ⓘ Description (ENGLISH) must be less than ${FIELD_CHAR_LENGTH.ENGLISH_DESCRIPTION} characters.`;
            error = true;
            toast.warn(errorsFields.description_en);
          }
        } else if (keyName === 'description_ar') {
          if (
            state.data.description_ar.length >
            FIELD_CHAR_LENGTH.ARABIC_DESCRIPTION
          ) {
            errorsFields.description_ar = `ⓘ Description (عربي) must be less than ${FIELD_CHAR_LENGTH.ARABIC_DESCRIPTION} characters.`;
            error = true;
            toast.warn(errorsFields.description_ar);
          }
        }
      }
    });

    setErrors(errorsFields);
    return error;
  };
  const handelNext = () => {
    dispatch(
      actionSetListingData({
        ...state.data,
        description_en: state.data.description_en,
      }),
    );
    dispatch(
      actionSetListingData({
        ...state.data,
        description_ar: state.data.description_ar,
      }),
    );
    if (!handleValidations()) {
      return addStep();
    }
  };

  const setRequiredAttributes = async (cat: Category) => {
    let pendingAllAttributes =
      state.all_attributes?.filter((i) => i.custom) || [];
    let pendingSelectAttributes =
      state.data.select_attrs?.filter((i) => i.custom) || [];
    let pendingNumericAttributes =
      state.data.numeric_attrs?.filter((i) => i.custom) || [];
    let pendingBooleanAttributes =
      state.data.boolean_attrs?.filter((i) => i.custom) || [];
    cat?.attributes?.map((attr: any) => {
      attr.values_en = [];
      attr.values_ar = [];
      attr.is_variable = false;
      attr.values_images = [];
      pendingAllAttributes = [...pendingAllAttributes, attr];
      if (attr.type === AttributeType.NUMERIC) {
        pendingNumericAttributes = [...pendingNumericAttributes, attr];
      }
      if (attr.type === AttributeType.SELECT) {
        pendingSelectAttributes = [...pendingSelectAttributes, attr];
      }

      if (attr.type === AttributeType.BOOLEAN) {
        pendingBooleanAttributes = [...pendingBooleanAttributes, attr];
      }
    });
    dispatch(actionSetAllAttributes([...pendingAllAttributes]));
    dispatch(
      actionSetListingData({
        ...state.data,
        category: cat,
        category_id: cat.id,
        boolean_attrs: [...pendingBooleanAttributes],
        select_attrs: [...pendingSelectAttributes],
        numeric_attrs: [...pendingNumericAttributes],
        combinations_table: [],
      }),
    );
  };

  return (
    <>
      <Wrapper>
        <div className="row d-flex align-items-center justify-content-center">
          <div className="col">
            <CardStyled>
              <div className="head">
                <h1>Listing information</h1>
              </div>
              <Form layout="vertical">
                <Form.Item
                  label={
                    <Row className="justify-between w-full align-middle">
                      <Label
                        color="#00273380"
                        style={{
                          marginBottom: '0px',
                          alignSelf: 'center',
                          fontSize: '16px',
                        }}
                      >
                        Item name (English) {RequiredSign()}
                      </Label>
                      <OneLanguageTranslateButton
                        onClick={async () => {
                          const word = state.data.name_en;
                          await UtilitiesRepository.translateText(word).then(
                            (res: string) => {
                              dispatch(
                                actionSetListingData({
                                  ...state.data,
                                  name_ar: res,
                                }),
                              );
                            },
                          );
                        }}
                      />
                      <Checkbox
                        isSelected={autoTuneName}
                        onChange={(e) => setAutoTuneName(e.target.checked)}
                        className="mr-4"
                      >
                        Auto-Tune
                      </Checkbox>
                    </Row>
                  }
                  tooltip="Please provide a descriptive name mentioning name and basic attributes."
                  extra={
                    errors?.name_en && (
                      <span
                        className="text-danger"
                        style={{ marginTop: '10px', display: 'block' }}
                      >
                        {errors?.name_en}
                      </span>
                    )
                  }
                >
                  <Input
                    type="text"
                    name="name_en"
                    placeholder="iPhone 16 Pro Max"
                    value={state?.data?.name_en}
                    onChange={(e) => {
                      const value = e.target.value;
                      dispatch(
                        actionSetListingData({ ...state.data, name_en: value }),
                      );
                    }}
                    onBlur={(e) => {
                      if (autoTuneName) {
                        const value = e.target.value;
                        const words = value.split(' ');
                        const capitalizedWords = words.map((word, index) => {
                          if (
                            index === 0 ||
                            !['and', 'or', 'the', 'of'].includes(
                              word.toLowerCase(),
                            )
                          ) {
                            return word.charAt(0).toUpperCase() + word.slice(1);
                          }
                          return word;
                        });
                        const capitalizedValue = capitalizedWords.join(' ');

                        // Replace all double (or more) spaces with a single space
                        const noSpacesValue = capitalizedValue.replace(
                          /\s+/g,
                          ' ',
                        );

                        // Replace any Hindi numbers ١٢٣٤٥٦٧٨٩ with English numbers 123456789
                        const finalValue = noSpacesValue.replace(
                          /[٠١٢٣٤٥٦٧٨٩]/g,
                          (match) => {
                            return String.fromCharCode(
                              match.charCodeAt(0) - 1632 + 48,
                            );
                          },
                        );
                        dispatch(
                          actionSetListingData({
                            ...state.data,
                            name_en: finalValue,
                          }),
                        );
                      }
                    }}
                    maxLength={128}
                    allowClear
                    showCount
                    required
                  />{' '}
                  <HelpBox
                    description={
                      <span
                        style={{
                          color: '#00273380',
                        }}
                      >
                        Click here to show/hide guidelines & examples for
                        English names
                      </span>
                    }
                    guidelines={[
                      'Use clear descriptive names:',
                      'Mention the brand:',
                      "Don't mention attribute values (if product is variant):",
                      'Capitalize major words:',
                    ]}
                    correctExamples={[
                      "Women's White Fabric Wallet with Metal Frame",
                      'Apple iPhone 14 Pro Max',
                      'Colgate Plax Mouthwash',
                      'Body Lotion Enriched with Olive Oil',
                    ]}
                    incorrectExamples={[
                      'Elegant Woman Purse',
                      'iPhone 14 Pro Max',
                      'Colgate Plax Mouthwash, Mint',
                      'Body lotion enriched with olive oil',
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <Row className="justify-between w-full align-middle">
                      <Label
                        color="#00273380"
                        style={{
                          marginBottom: '0px',
                          alignSelf: 'center',
                          fontSize: '16px',
                          width: '100% !important',
                        }}
                      >
                        Item name (عربي) {RequiredSign()}
                      </Label>
                      <OneLanguageTranslateButton
                        translatingArabicToEnglish
                        onClick={async () => {
                          const word = state.data.name_ar;
                          await UtilitiesRepository.translateText(
                            word,
                            true,
                          ).then((res: string) => {
                            dispatch(
                              actionSetListingData({
                                ...state.data,
                                name_en: res,
                              }),
                            );
                          });
                        }}
                      />
                    </Row>
                  }
                  tooltip="Please provide a descriptive name, if used translation, please double check it."
                  extra={
                    errors?.name_ar && (
                      <span
                        className="text-danger"
                        style={{ marginTop: '10px', display: 'block' }}
                      >
                        {errors?.name_ar}
                      </span>
                    )
                  }
                >
                  <Input
                    type="text"
                    dir="rtl"
                    name="name_ar"
                    placeholder="آيفون 16 برو ماكس"
                    value={state?.data?.name_ar}
                    onChange={handleChange}
                    maxLength={128}
                    minLength={20}
                    allowClear
                    showCount
                    required
                    onBlur={(e) => {
                      if (autoTuneName) {
                        const value = e.target.value;

                        // Replace all double (or more) spaces with a single space
                        const noSpacesValue = value.replace(/\s+/g, ' ');

                        // Replace any Hindi numbers ١٢٣٤٥٦٧٨٩ with English numbers 123456789
                        const finalValue = noSpacesValue.replace(
                          /[٠١٢٣٤٥٦٧٨٩]/g,
                          (match) => {
                            return String.fromCharCode(
                              match.charCodeAt(0) - 1632 + 48,
                            );
                          },
                        );
                        dispatch(
                          actionSetListingData({
                            ...state.data,
                            name_ar: finalValue,
                          }),
                        );
                      }
                    }}
                  />
                  <HelpBox
                    description={
                      <span
                        style={{
                          color: '#00273380',
                        }}
                      >
                        Click here to show/hide guidelines & examples for Arabic
                        names
                      </span>
                    }
                    locale="ar"
                    guidelines={[
                      'استخدم أسماء وصفية واضحة تعكس طبيعة المنتج.',
                      'قم بذكر العلامة التجارية إذا كان ذلك مناسبًا.',
                      'تجنب ذكر قيم الخصائص مثل اللون أو الحجم إذا كان المنتج يحتوي على متغيرات.',
                      'لا تقم بترجمة الأسماء الأصلية وحافظ عليها كما هي.',
                    ]}
                    correctExamples={[
                      'محفظة نسائية بيضاء من القماش مع إطار معدني',
                      'آبل آيفون 14 برو ماكس',
                      'غسول الفم كولجيت بلاكس',
                      'جهاز بلاي ستيشن 5 من سوني -أو- جهاز PlayStation 5 من سوني',
                    ]}
                    incorrectExamples={[
                      'محفظة نسائية أنيقة',
                      'آيفون 14 برو ماكس',
                      'غسول الفم كولجيت بلاكس، نعناع',
                      'جهاز محطّة اللعب 5 من سوني',
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <Row className="justify-between w-full align-middle">
                      <Label
                        color="#00273380"
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        Category {RequiredSign()}
                      </Label>
                    </Row>
                  }
                  tooltip="Please choose the most accurate category for your item."
                  extra={
                    errors.category ? <Error text={errors.category} /> : ''
                  }
                >
                  <div className="d-flex align-items-center">
                    <SelectDiv
                      text={`${
                        selected_category
                          ? selected_category?.name_en +
                            ' | ' +
                            selected_category?.name_ar
                          : 'Choose category'
                      }`}
                      click={() => setIsModalVisible(true)}
                      active={selected_category !== null ? true : false}
                    />
                  </div>
                </Form.Item>
                <Form.Item
                  label={
                    <Row className="justify-between w-full align-middle">
                      <Label
                        color="#00273380"
                        style={{
                          marginBottom: '0px',
                          alignSelf: 'center',
                          fontSize: '16px',
                          width: '100% !important',
                        }}
                      >
                        Item Barcode{' '}
                      </Label>
                    </Row>
                  }
                  tooltip="Please provide the exact manufacturer barcode of the item."
                >
                  <Input
                    type="text"
                    dir="ltr"
                    name="barcode"
                    placeholder="CM8071505094017-SRN48"
                    value={state?.data?.barcode}
                    onChange={handleChange}
                    maxLength={128}
                    minLength={0}
                    allowClear
                    showCount
                  />
                </Form.Item>
              </Form>
              <div className="checkBoxes col-lg-4  d-flex">
                <Label
                  color="#00273380"
                  style={{
                    alignSelf: 'center',
                    marginRight: '10px',
                    fontSize: '16px',
                  }}
                >
                  Condition {RequiredSign()}
                </Label>

                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={'false'}
                    className="my-1"
                    name="radio-buttons-group"
                    onChange={(e) => {
                      dispatch(
                        actionSetListingData({
                          ...state.data,
                          is_used: e.target.value === 'true' ? true : false,
                        }),
                      );
                    }}
                  >
                    <div className="d-flex">
                      <FormControlLabel
                        value="false"
                        control={<Radio color="success" />}
                        label="New"
                      />
                      <FormControlLabel
                        value="true"
                        control={<Radio color="success" />}
                        label="Used"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <br />
              <HelpBox
                description={
                  <Label
                    color="#00273380"
                    style={{
                      fontSize: '16px',
                      marginLeft: '-10px',
                    }}
                  >
                    Item Description {RequiredSign()}
                  </Label>
                }
                locale="en"
                guidelines={[
                  'Make sure that the description matches the item.',
                  "Don't start with: 'Description:' or 'About this item'.",
                  'Description should be detailed and informative.',
                  'Double check any spelling or grammatical errors.',
                  'No promotional content.',
                ]}
                correctExamples={[]}
                incorrectExamples={[]}
              />
              <Row>
                <Label
                  color="#00273380"
                  style={{
                    fontSize: '14px',
                    alignSelf: 'center',
                    margin: '0px',
                  }}
                >
                  English Description {RequiredSign()}
                </Label>
                <OneLanguageTranslateButton
                  onClick={async () => {
                    const word = state.data.description_en;
                    await UtilitiesRepository.translateHTML(word).then(
                      (res: string) => {
                        dispatch(
                          actionSetListingData({
                            ...state.data,
                            description_ar: res,
                          }),
                        );
                      },
                    );
                  }}
                />
              </Row>
              <p
                className={`charac-left  ${
                  state.data.description_en
                    ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
                    .replaceAll(/&nbsp;/g, ' ')
                    .trim().length < DESCRIPTION_MIN_LENGTH
                    ? 'text-danger'
                    : ''
                }`}
              >
                {state.data.description_en
                  ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
                  .replaceAll(/&nbsp;/g, ' ')
                  .trim().length - DESCRIPTION_MIN_LENGTH}{' '}
                characters left
              </p>
              <div className="d-flex">
                <CKEditor
                  editor={ClassicEditor}
                  data={state.data.description_en}
                  config={{
                    placeholder:
                      'Describe your item in detail. Be sure to include all the key features and specifications. You can use HTML Markup.',
                  }}
                  onChange={(_, editor) => {
                    dispatch(
                      actionSetListingData({
                        ...state.data,
                        description_en: editor.getData(),
                      }),
                    );
                  }}
                />
              </div>
              {errors.description_en ? (
                <Error text={errors.description_en} />
              ) : (
                ''
              )}
              <div>
                <Row>
                  <Label
                    color="#00273380"
                    style={{
                      fontSize: '14px',
                      alignSelf: 'center',
                      margin: '0px',
                    }}
                  >
                    Arabic Description{RequiredSign()}
                  </Label>
                  <OneLanguageTranslateButton
                    translatingArabicToEnglish
                    onClick={async () => {
                      const word = state.data.description_ar;
                      await UtilitiesRepository.translateHTML(word, true).then(
                        (res: string) => {
                          dispatch(
                            actionSetListingData({
                              ...state.data,
                              description_en: res,
                            }),
                          );
                        },
                      );
                    }}
                  />
                </Row>
                <p
                  className={`charac-left  ${
                    state.data.description_ar
                      ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
                      .replaceAll(/&nbsp;/g, ' ')
                      .trim().length < DESCRIPTION_MIN_LENGTH
                      ? 'text-danger'
                      : ''
                  }`}
                >
                  {state.data.description_ar
                    ?.replaceAll(/<\/?[^>]+(>|$)/g, '')
                    .replaceAll(/&nbsp;/g, ' ')
                    .trim().length - DESCRIPTION_MIN_LENGTH}{' '}
                  characters left
                </p>
              </div>
              <div className="d-flex">
                <CKEditor
                  editor={ClassicEditor}
                  data={state.data.description_ar}
                  config={{
                    language: 'ar',
                    placeholder:
                      'صف المنتج الخاص بك بالتفصيل. تأكد من تضمين جميع الميزات والمواصفات الرئيسية. يمكنك استخدام ترميز HTML.',
                  }}
                  onChange={(_, editor) => {
                    dispatch(
                      actionSetListingData({
                        ...state.data,
                        description_ar: editor.getData(),
                      }),
                    );
                  }}
                />
              </div>
              {errors.description_ar ? (
                <Error text={errors.description_ar} />
              ) : (
                ''
              )}
              <div className="end">
                <Button
                  onClick={handelNext}
                  color="success"
                  style={{
                    width: '150px',
                  }}
                >
                  Next step
                </Button>
              </div>
            </CardStyled>
          </div>
        </div>
      </Wrapper>

      {/* Category Modal */}
      <CategoryModal
        isModalVisible={isModalVisible}
        hideModal={() => setIsModalVisible(false)}
        onConfirm={async (cat: AbstractCategoryWithSubcategories) => {
          if (cat.sub_categories?.length) {
            toast.warn('Please select the most specific category');
            return;
          }
          const fullCat = await SharedRepository.getCategoryDetails(
            cat.id,
          ).then((res) => {
            if (!res) {
              toast.warn('Error fetching category details');
              return;
            }
            return res;
          });
          await setRequiredAttributes(fullCat!);
          setIsModalVisible(false);
        }}
        onClear={() => {
          dispatch(
            actionSetListingData({
              ...state.data,
              numeric_attrs: [],
              boolean_attrs: [],
              select_attrs: [],
              category_id: 0,
              category: undefined,
            }),
          );
          setIsModalVisible(false);
        }}
      />
      {/* <BarcodeModal setShow={setBarcodeModalShow} /> */}
    </>
  );
}
